import { useMutation } from "@tanstack/react-query";
import type { CatalogDelayCode } from "../../codes/models/CatalogDelayCode";
import {
  deleteDelay,
  moveDelayCode,
  reorderDelays,
  upsertDelay,
} from "../../codes/repositories/ConfigurationDelayRepository";

export const useUpsertDelayCodeMutation = () => {
  return useMutation({
    mutationFn: async (delayCode: CatalogDelayCode) => {
      const resp = await upsertDelay(delayCode);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useDeleteDelayCodeMutation = () => {
  return useMutation({
    mutationFn: async (delayCodeId: number) => {
      const resp = await deleteDelay(delayCodeId);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useReorderDelayCodesMutation = () => {
  return useMutation({
    mutationFn: async ({
      delayCodeId,
      aboveDelayCodeId,
    }: {
      delayCodeId: (string | number)[];
      aboveDelayCodeId: number | null;
    }) => {
      const resp = await reorderDelays(delayCodeId, aboveDelayCodeId);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};

export const useMoveDelayCodeMutation = () => {
  return useMutation({
    mutationFn: async ({
      delayCodeId,
      moveDown,
    }: {
      delayCodeId: number;
      moveDown: boolean;
    }) => {
      const resp = await moveDelayCode(delayCodeId, moveDown);
      if (!resp.ok) throw new Error(resp.message);
      return resp;
    },
  });
};
